// extracted by mini-css-extract-plugin
export default {"step__image":"ImgStepItem_step__image__8v2hP","step":"ImgStepItem_step__K3P-j","step__title":"ImgStepItem_step__title__R2ch5","step__text":"ImgStepItem_step__text__5sEW8"};